import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-full" }
const _hoisted_2 = { class: "hidden lg:fixed lg:inset-y-0 lg:flex lg:w-72 lg:flex-col select-none" }
const _hoisted_3 = { class: "flex grow flex-col overflow-y-auto border-r border-gray-200 bg-white px-6 pb-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "flex flex-1 flex-col" }
const _hoisted_6 = {
  role: "list",
  class: "flex flex-1 flex-col gap-y-4"
}
const _hoisted_7 = { class: "lg:pl-72" }
const _hoisted_8 = { class: "py-5" }
const _hoisted_9 = { class: "px-5" }

import { ref, onMounted } from 'vue'
import type { Route } from '@/interfaces'
import { Navigation } from '@component/Nav'
import { useNotInvoiced } from '@/composables'
import { TopBar } from '@component/Miscellaneous'
import { HomeIcon, IdentificationIcon, CircleStackIcon, UserGroupIcon, BriefcaseIcon, BuildingOfficeIcon, UserPlusIcon, WrenchIcon, LifebuoyIcon, CubeIcon, WrenchScrewdriverIcon, RectangleStackIcon } from '@heroicons/vue/24/outline'


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {

const counter = ref<number>(0);

const routes = ref<Route[]>([
  { name: "Dashboard", route: "Admin.Dashboard", icon: HomeIcon, prefix: "Admin.Dashboard" },
  { name: "Referentie codes", route: "Admin.Forms.Reference.Dashboard", icon: IdentificationIcon, prefix: "Admin.Forms.Reference." },
  {
    name: "Data beheer",
    route: "",
    icon: CircleStackIcon,
    prefix: "Admin.Data.",
    children: [
      { name: "Medewerkers", route: "Admin.Data.Employees.Dashboard", icon: UserGroupIcon, prefix: "Admin.Data.Employees." },
      { name: "Bedrijven", route: "Admin.Data.Companies.Dashboard", icon: BriefcaseIcon, prefix: "Admin.Data.Companies." },
      { name: "Objecten", route: "Admin.Data.Objects.Dashboard", icon: BuildingOfficeIcon, prefix: "Admin.Data.Objects." },
      { name: "Contactpersonen", route: "Admin.Data.ContactPersons.Dashboard", icon: UserPlusIcon, prefix: "Admin.Data.ContactPersons." },
      { name: "Diensten", route: "Admin.Data.Services.Dashboard", icon: WrenchIcon, prefix: "Admin.Data.Services." },
      { name: "Calamiteiten", route: "Admin.Data.Disasters.Dashboard", icon: LifebuoyIcon, prefix: "Admin.Data.Disasters." },
      { name: "Materialen", route: "Admin.Data.Materials.Dashboard", icon: CubeIcon, prefix: "Admin.Data.Materials." },
      { name: "Middelen", route: "Admin.Data.Resources.Dashboard", icon: WrenchScrewdriverIcon, prefix: "Admin.Data.Resources." },
    ]
  }
]);

const { formRoutes } = useNotInvoiced([
  { name: "Project prijs", route: "Admin.Forms.ProjectPrice.Dashboard", icon: "PP", prefix: "Admin.Forms.ProjectPrice.", open: 0 },
  { name: "Regie prijs", route: "Admin.Forms.HourlyPrice.Dashboard", icon: "RP", prefix: "Admin.Forms.HourlyPrice.", open: 10 },
  { name: "Glasbewassing CSU", route: "Admin.Forms.Glasbewassing.Dashboard", icon: "CSU", prefix: "Admin.Forms.Glasbewassing.", open: 0 },
  { name: "Calamiteiten reiniging", route: "Admin.Forms.Calamiteiten.Dashboard", icon: "CR", prefix: "Admin.Forms.Calamiteiten.", open: 0 }
]);

const hiddenRoutes = ref<Route[]>([
  { name: "Taken registratie", route: "Admin.Secret.Forms.TaskRegister.Dashboard", icon: RectangleStackIcon, prefix: "Admin.Secret.Forms.TaskRegister." }
]);

const bottomRoutes = ref<Route[]>([
  { name: "Taken registratie", route: "Forms.TaskRegister", icon: RectangleStackIcon, prefix: "UnkownRoutes.", external: true },
]);

onMounted(() => {
  const body = document.getElementById("body");

  body?.classList.remove("bg-zinc-900");
  body?.classList.add("h-full");
});

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (counter.value++)),
            disabled: counter.value === 10,
            class: "flex h-16 shrink-0 items-center justify-center text-center font-bold text-xl font-mono"
          }, " VEHA Ontzorgt B.V. ", 8, _hoisted_4),
          _createElementVNode("nav", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createVNode(_unref(Navigation), { routes: routes.value }, null, 8, ["routes"]),
              _createVNode(_unref(Navigation), {
                title: "Formulieren",
                routes: _unref(formRoutes),
                "is-grouped": ""
              }, null, 8, ["routes"]),
              (counter.value === 10)
                ? (_openBlock(), _createBlock(_unref(Navigation), {
                    key: 0,
                    title: "Geheime paginas",
                    routes: hiddenRoutes.value,
                    "is-grouped": ""
                  }, null, 8, ["routes"]))
                : _createCommentVNode("", true),
              _createVNode(_unref(Navigation), {
                routes: bottomRoutes.value,
                "is-bottom": ""
              }, null, 8, ["routes"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(TopBar)),
        _createElementVNode("main", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_RouterView)
          ])
        ])
      ])
    ])
  ]))
}
}

})